import { render } from "./Ranges.vue?vue&type=template&id=0d968ce6"
import script from "./Ranges.vue?vue&type=script&lang=js"
export * from "./Ranges.vue?vue&type=script&lang=js"

import "./Ranges.vue?vue&type=style&index=0&id=0d968ce6&lang=css"
script.render = render

export default script